export const CHECKOUT_BASE = 'https://pay.hotmart.com/K98488159N?off=dnutfmp1&checkoutMode=10';
export const TARGET_DATE = '2026-10-01T00:00:00-04:00';

export const images = {
  cover: 'https://cdn.magicpatterns.com/uploads/rhm5fVhGsvWb7Y8rA3Vbiw/Imagen_1_Beatriz.jpg',
  portrait: 'https://cdn.magicpatterns.com/uploads/oUatpZWRTJgYsKqM15JvQe/Imagen_2_Drive.jpg',
  mockup: 'https://cdn.magicpatterns.com/uploads/rLA7zXw9yKp8NrKxtGLerN/Imagen_3_Beatriz.jpg',
  testimonial: 'https://cdn.magicpatterns.com/uploads/1VapLtqiGxBLyk7rLCDznP/Testimonio_9.jpg',
};

export const strategistTraits = [
  'Es irresistiblemente sexy.',
  'Está vista, al punto de tener al hombre que quiere a sus pies.',
  'Es segura.',
  'Se ama.',
  'Sabe colocar límites de manera asertiva.',
  'No anda repitiendo patrones.',
  'Pone fechas, para que no jueguen con su tiempo.',
  'Piensa más con la cabeza y menos con el corazón — por eso no se deja estafar tan fácilmente.',
];

export const forYouItems = [
  'Sientes que no te valoran o no te respetan.',
  'Perdiste tu seguridad como mujer.',
  'Te sientes invisible.',
  'Te falta ser estratégica al momento de tener relaciones amorosas, para no repetir patrones.',
];

export const testimonials = [
  {
    label: 'Dejó de ser invisible',
    text: 'Después de 3 años sola, eligiendo estar en modo invisible, me decidí a hacer Elegida y aplicando solo parte de los ejercicios los resultados fueron inmediatos. Ya llevamos 3 meses juntos, es un hombre honesto, constante y presente. Mi ansiedad en las relaciones se fue.',
    signature: '— Alumna de Elegida, edición octubre 2025',
    image: null,
  },
  {
    label: 'Puso la fecha',
    text: 'Luego de ser Guadalupita por años, gracias a este método, por primera vez en mi vida —tengo 48 años— le pude decir a un hombre: si quieres conversar conmigo, invítame a almorzar. Y también le pude decir el día que tengo disponible. Esto es un súper logro para mí.',
    signature: '— Alumna de Elegida, 48 años',
    image: null,
  },
  {
    label: 'La eligieron',
    text: 'Ya somos formales, conocí a sus papás y él a los míos. Y dentro de un mes nos mudamos juntos.',
    signature: '— Andry, alumna de Elegida',
    image: 'https://cdn.magicpatterns.com/uploads/1VapLtqiGxBLyk7rLCDznP/Testimonio_9.jpg',
  },
  {
    label: 'La cuidan',
    text: 'Me pintaron el cuarto sin pedirlo. Yo estaba sacando las cosas para pintar y me dijo: el fin de semana lo pintamos. Nunca me habían ofrecido ayuda así.',
    signature: '— Alumna de Elegida',
    image: null,
  },
  {
    label: 'La presentó',
    text: 'Me volvieron aún más formal: me presentó a sus papás.',
    signature: '— Alumna de Elegida',
    image: null,
  },
];

export const includes = [
  '30 terapias grabadas (acceso en Hotmart por 1 año)',
  '30 días de acompañamiento profesional por WhatsApp',
  'Sesión en vivo de diagnóstico — 1 de octubre',
  'Sesión en vivo de cierre — 29 de octubre',
  'Comunidad privada Mujer Elegida',
];

export const gifts = [
  'Masterclass: Meditaciones de Reprogramación Sexual',
  'Masterclass: Los Secretos de la Voz Erótica',
  'Masterclass: Los Secretos de la Atracción Subconsciente',
  'Práctica de Movimientos para despertar tu sensualidad',
];

export const faqs = [
  {
    q: '¿Cómo sé si esto es para mí?',
    a: 'Si sientes que das todo y aun así no te ven, es para ti.',
  },
  {
    q: '¿Es terapia o es un curso?',
    a: 'Es un método terapéutico conductual con acompañamiento real, no solo contenido y formación.',
  },
  {
    q: '¿Cuánto dura?',
    a: '30 días, con acompañamiento profesional, y acceso a las clases por 1 año.',
  },
  {
    q: '¿Y si no me funciona?',
    a: 'Tienes 7 días de garantía por Hotmart. Si no es para ti, se te devuelve el 100%.',
  },
];
